import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=2cf255f7&scoped=true&"
import script from "./Teaser.vue?vue&type=script&lang=ts&"
export * from "./Teaser.vue?vue&type=script&lang=ts&"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=2cf255f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf255f7",
  null
  
)

export default component.exports